// Impôt avis social (CSG + CRDS + RSA)
import compute from '../computeResultSocialCharges';

const computeSocialCharges = (rip, { landRentalResults, furnishedRentalResults }) => {
    const { computeWithNewSocialChargeRate } = rip;
    const socialCharges = compute(landRentalResults, computeWithNewSocialChargeRate) + compute(furnishedRentalResults, computeWithNewSocialChargeRate);

    return { socialCharges };
};

export default computeSocialCharges;
